import ReportDataTable from "./ReportDataTable";
import { ReportRow } from "../types";

const InventoryReport = ({ rows }: { rows: ReportRow[] }) => (
  <ReportDataTable rows={rows} emptyMessage="No inventory report data found." />
);

export default InventoryReport;
